const guiColors = {
    'motion-primary': '#4DB5FF',
    'motion-primary-transparent': 'rgba(77, 181, 255, 0.9)',
    'motion-tertiary': 'rgb(204, 156, 51)',

    'looks-secondary': '#4DB5FF',
    'looks-transparent': 'rgba(255, 190, 77, 0.35)',
    'looks-light-transparent': '#ff4d4d26',
    'looks-secondary-dark': 'hsla(0, 42%, 51%, 1)',

    'data-primary': '#6992ff',

    'extensions-primary': '#4DB5FF',
    'extensions-tertiary': 'rgb(189, 99, 15)',
    'extensions-transparent': 'hsla(10, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#4DB5FF'
};

const blockColors = {
    checkboxActiveBackground: 'rgb(255, 183, 76)',
    checkboxActiveBorder: 'rgb(204, 130, 51)'
};

export {
    guiColors,
    blockColors
};